import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import React from 'react'
import { object } from 'prop-types'
import styled from 'styled-components'
import PrazoEntrega from '../../components/PrazoEntrega/PrazoEntrega'
import {
  ROUTE_BASEPATH,
} from '../../constants'
import { URLS_APP } from '../../config'

import { ReactComponent as TruckIcon } from '../../assets/icons/truck.svg'
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow.svg'
import { ReactComponent as OrangeArrowIcon } from '../../assets/icons/orange-arrow.svg'

import { navigate } from '@reach/router'

const Texto = styled.p`
  ${StyleGuide.tipografia.textoDefault};
  ${( { isErro } ) => isErro && `color: ${StyleGuide.cores.vermelhoErroColor}`}
  ${( { fontWeight } ) => fontWeight === 'bold' ? StyleGuide.boldFonte : StyleGuide.defaultFonte};
  line-height: 1.6;
  margin: ${( { margin } ) => margin || `0 0 5px 0`};
`

const Date = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  color: ${( { type } ) => type === 'Curadoria' ? '#009BBF;' : '#EB8100'};
`

const Container = styled.div`
  padding: 20px 30px 5px 37px;
  display: flex;
  border-top: 1px solid #f4f4f5;
  margin-top: 10px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 20px 10px 5px 24px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
  }

  .arrow-div {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .prazo-entrega {
    ${StyleGuide.tipografia.textoPequeno};
    color: ${StyleGuide.cores.cinza400};
    padding-top: 10px;
  }
  .bold-text {
    font-weight: 600;
  }
  .normal-text {
    font-weight: 400;
  }
`

const TextoComplemento = styled.p`
  ${StyleGuide.tipografia.textoPequeno};
  color: ${StyleGuide.cores.cinza400};
  padding-top: 10px;

  a {
    font-weight: 700;
    color: #009BBF;
    text-decoration: underline;
  }
`

const TextoWrapper = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 5px;
  padding-left: 15px;
  p {
    margin: 0;
  }
`

const StatusEntrega = ( { ultimoPedido } ) => {
  return (
    <Container>
      <TruckIcon />

      <TextoWrapper>
        <div className="card-header">
          <div className="status-date">
            <Texto
              fontWeight="bold"
              margin="5px 5px 0px 0"
            >
              {' Status da entrega '}
            </Texto>

            <Date
              margin="5px 5px 0px 0"
              type={ ultimoPedido?.modalidade }
            >
              {`${ultimoPedido ? ultimoPedido.mesTAG : ''}`}
            </Date>
          </div>

          <div
            className="arrow-div"
            onClick={ () => navigate( `${ROUTE_BASEPATH}${
              URLS_APP.BASE_PATH ? '/' : ''
            }${'meus-kits'}` ) }
          >
            {ultimoPedido?.modalidade === 'Curadoria' ? (
              <ArrowIcon />
            ) : (
              <OrangeArrowIcon />
            )}
          </div>
        </div>

        <PrazoEntrega previsaoEntrega={ ultimoPedido.previsaoEntrega } />

        {ultimoPedido.transportadora.nome ?
          <TextoComplemento>
            {` Empresa responsável pela entrega: ${ultimoPedido.transportadora.nome}. `}

            {ultimoPedido.transportadora.linkRastreamento ? (
              <a
                href={ ultimoPedido.transportadora.linkRastreamento }
                rel="noopener noreferrer"
                target="_blank"
              >
                {' Acompanhe seu pedido '}
              </a>
            ) : (
              ''
            )}
          </TextoComplemento> : null}
      </TextoWrapper>
    </Container>
  )
}

StatusEntrega.propTypes = {
  'ultimoPedido': object.isRequired
}

export default StatusEntrega
